<div class="container-fluid" *ngIf="PdfDataList.length !==0">
  <div class="row">
    <div class="col-md-12 news-marquee">
      <div class="d-flex justify-content-between align-items-center breaking-news">
        <div class="d-flex flex-row flex-grow-1 flex-fill justify-content-center  py-2 px-1 news news-button"
          *ngIf="color === 'pur'">
          <span class="d-flex align-items-center" cbicTranslate="menu.NewsUpdates" title="News Updates"></span></div>
        <div class="d-flex flex-row flex-grow-1 flex-fill justify-content-center  py-2  px-1 news news-button FontBlack"
          *ngIf="color === 'bule'">
          <span class="d-flex align-items-center" cbicTranslate="menu.NewsUpdates" title="News Updates"></span></div>


        <marquee class="news-scroll" behavior="scroll" direction="left" onmouseover="this.stop();"
          onmouseout="this.start();">

          <span *ngFor="let tickers of tickersList">
            <span *ngIf="flag==='En'">
              <!-- {{tickers.titleEn}} -->
              <span *ngFor="let pdflist of PdfDataList">
                <a *ngIf="tickers.id == pdflist.content?.id && pdflist.docTitleEn !== null " [routerLink]=""
                  (click)="ViewPdf(pdflist.filePathEn)">
                  {{pdflist.docTitleEn}}&nbsp; <i *ngIf="pdflist.docType ==='pdf'" class="pdf-icon"
                    aria-hidden="true"></i>
                  <i *ngIf="pdflist.docType ==='xls' || pdflist.docType ==='xlsx' || pdflist.docType ==='xlsb'"
                    class="xls-icon" aria-hidden="true"></i>
                  <i *ngIf="pdflist.docType ==='link'" class="dark external-link " aria-hidden="true"></i> &nbsp;
                </a>
              </span><span class="dot"></span>
            </span>
            <span *ngIf="flag==='Hi'">
              <!-- {{tickers.titleHi}} -->
              <span *ngFor="let pdflist of PdfDataList">
                <a *ngIf="tickers.id == pdflist.content?.id && pdflist.docTitleHi!=null " [routerLink]=""
                  (click)="ViewPdf(pdflist.filePathHi)">
                  {{pdflist.docTitleHi}}&nbsp;
                  <i *ngIf="pdflist.docType ==='pdf'" class="pdf-icon" aria-hidden="true"></i>
                  <i *ngIf="pdflist.docType ==='xls' || pdflist.docType ==='xlsx' || pdflist.docType ==='xlsb'"
                    class="xls-icon" aria-hidden="true"></i>
                  <i *ngIf="pdflist.docType ==='link'" class="dark external-link " aria-hidden="true"></i> &nbsp;
                </a>
                <a *ngIf="tickers.id == pdflist.content?.id && pdflist.docTitleHi===null  " [routerLink]=""
                  (click)="ViewPdf(pdflist.filePathEn)">
                  {{pdflist.docTitleEn}}&nbsp;<i *ngIf="pdflist.docType ==='pdf'" class="pdf-icon"
                    aria-hidden="true"></i>
                  <i *ngIf="pdflist.docType ==='xls' || pdflist.docType ==='xlsx' || pdflist.docType ==='xlsb'"
                    class="xls-icon" aria-hidden="true"></i>
                  <i *ngIf="pdflist.docType ==='link'" class="external-link" aria-hidden="true"></i> &nbsp;
                </a>
                <span
                  *ngIf="tickers.id == pdflist.content?.id && (pdflist.filePathHi === '' || pdflist.filePathHi === null)  &&  pdflist.docTitleHi!=null ">

                  {{pdflist.docTitleHi}}&nbsp;

                </span>
              </span><span class="dot"></span>
            </span>
          </span>
        </marquee>
        <div class=" py-2 text-white px-1 viewall-btn" *ngIf="color === 'pur'">&nbsp;
          <a [routerLink]="['/entities/view-sticker']" target="_black" title="View All">
            <span cbicTranslate="menu.ViewAll"></span>
          </a>
        </div>

        <div class=" py-2 text-white px-1 viewall-btn blackbtn" *ngIf="color === 'bule'">&nbsp;
          <a [routerLink]="['/entities/view-sticker']" target="_black" title="View All">
            <span cbicTranslate="menu.ViewAll"></span>
          </a>
        </div>

      </div>
    </div>
  </div>
</div>